module.exports = __webpack_public_path__ + "img/logistic-robotics.532d0db7.png";